import { render, staticRenderFns } from "./RiskWorkItemDialog.vue?vue&type=template&id=66cdbcfa&scoped=true"
import script from "./RiskWorkItemDialog.vue?vue&type=script&lang=js"
export * from "./RiskWorkItemDialog.vue?vue&type=script&lang=js"
import style0 from "./RiskWorkItemDialog.vue?vue&type=style&index=0&id=66cdbcfa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cdbcfa",
  null
  
)

export default component.exports